export default __webpack_public_path__ + "static/city-fe90dcdb16cb47afdf1321221b33cfb1.webp";